export default __webpack_public_path__ + "static/Wijnand_Ybema_2-50778334ad43e1b813512deb3a878768.jpg";